<template>
<div>
  <span v-if="this.status === 0">
    <v-icon left color="grey">visibility_off</v-icon> Noch nicht freigeschaltet 
  </span>
  <span v-if="this.status === 1">
    <v-icon left>visibility</v-icon> Freigeschaltet und aktiv
  </span>
  <span v-if="this.status === 2">
    <v-icon left color="grey">visibility_off</v-icon> Beendet
  </span>
   <span v-if="this.status === 3">
    <v-icon left color="grey">visibility_off</v-icon> Aufgeschoben
  </span>
</div>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      default: false
    }
  },
  components: {},
  data () {
    return {}
  },
  filters: {},
  created () {},
  mounted () {},
  computed: {}
}
</script>

<style >
</style>